import React, { useState, useEffect } from 'react';
import { formatCustom } from '../../../utils/TimeUtils';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { withRouter } from 'react-router-dom';
import Row from '../../tag/Row';
import { FormattedMessage } from 'react-intl';
import Span from '../../tag/Span';
import OTButtonGroup from '../../tag/OTButtonGroup';
import OTButton from '../../tag/OTButton';
import AppointmentReserveConfirmModal from './AppointmentReserveConfirmModal';
import NoReservableAppointmentsNotification from './NoReservableAppointmentsNotification';
import Calendar from '../ReservationCalendar/Calendar';
import { APPOINTMENTS } from '../../../data/reducer';
import {
  doGetTimesForClinic,
  doGetTimesForMaternityClinic,
  doReserveAppointment,
  hideReservationModal,
  resetAppointmentReservation,
  showReservationModal,
} from '../../../data/appointment/actions';
import Loader from '../../Loader';
import {
  mapReservationAppointmentsForList,
  mapReservationTimesForCalendar,
  resolveComment,
} from '../../../utils/AppointmentUtils';
import ReservationsList from '../ReservationsList';
import { MATERNITY_ULTRA_KEY } from '../../../definitions/AppointmentConstants';
import moment from 'moment';
import Alert from '../../Alert';

let { id: module_id } = module;

const LIST_VIEW = 'LIST';
const CALENDAR_VIEW = 'CALENDAR';

function ReservationCalendarPage(props) {
  const {
    modalIsOpen,
    isReserving,
    showReservationModal,
    hideReservationModal,
    isFetching,
    error,
    data,
    selectedClinicKey,
    selectedReasonKey,
    dueDate,
    doGetTimesForClinic,
    doGetTimesForMaternityClinic,
    doReserveAppointment,
    clinicData,
    resetAppointmentReservation,
    history,
  } = props;

  const [selectedTime, setSelectedTime] = useState(null);
  const [showCalendar, setShowCalendar] = useState(false);
  const [selectionView, setSelectionView] = useState(null);
  const [maternityUltra, setMaternityUltra] = useState(false);

  useEffect(() => {
    const currentClinic = clinicData.find(
      (clinic) => clinic.key === selectedClinicKey
    );
    const isMaternityUltra =
      selectedClinicKey.toString() === MATERNITY_ULTRA_KEY;

    setMaternityUltra(isMaternityUltra);

    if (isMaternityUltra) {
      const dueDateString = moment(dueDate).format(); // Defaults to an ISO string.
      doGetTimesForMaternityClinic(
        currentClinic.oid,
        selectedReasonKey,
        dueDateString
      );
    } else {
      doGetTimesForClinic(currentClinic.oid);
    }
  }, [selectedClinicKey, selectedReasonKey, maternityUltra, clinicData]);

  const hasReservationOptions = !isFetching && !error && !isEmpty(data);

  const handleCalendarView = () => {
    if (data && showCalendar != null) {
      setSelectionView(showCalendar ? CALENDAR_VIEW : LIST_VIEW);
      setShowCalendar(true);
    }
  };

  useEffect(() => {
    if (data && !isEmpty(data.filter((item) => !item.original))) {
      handleCalendarView();
    }
  }, [data, handleCalendarView]);

  function selectTime(time) {
    setSelectedTime(time);
  }

  function confirmTime() {
    const currentClinic = clinicData.find(
      (clinic) => clinic.key === selectedClinicKey,
      null
    );

    const reserveDto = {
      carePlan: currentClinic.carePlanId,
      schedule: selectedTime.scheduleId,
      serviceType: selectedTime.visitType || undefined,
      location: selectedTime.locationId,
      dateStart: selectedTime.dateStart,
      dateEnd: selectedTime.dateEnd,
      comment: resolveComment(selectedClinicKey, selectedReasonKey),
    };

    doReserveAppointment(reserveDto, history);
  }

  function previous() {
    history.goBack();

    // reset reservation data a while after navigation, so error is not shown
    setTimeout(resetAppointmentReservation, 1000);
  }

  return (
    <>
      {isFetching ? (
        <Loader />
      ) : (
        <div className="ot-mainview">
          <Row>
            <Span>
              <h1>
                <FormattedMessage id={`${module_id}.title`} />{' '}
                <FormattedMessage
                  id={resolveComment(selectedClinicKey, selectedReasonKey)}
                />
              </h1>
            </Span>
          </Row>
          {hasReservationOptions ? (
            <>
              {selectionView && (
                <Row>
                  <Span>
                    <h2 className={'subheading-gray'}>
                      <FormattedMessage
                        id={`${module_id}.select.time.${selectionView}`}
                      />
                    </h2>
                  </Span>
                </Row>
              )}
              {selectionView === CALENDAR_VIEW && (
                <Calendar
                  selectTime={selectTime}
                  selectedTime={selectedTime}
                  data={mapReservationTimesForCalendar(data)}
                />
              )}
              {selectionView === LIST_VIEW && (
                <ReservationsList
                  selectAndSubmit={(item) => {
                    selectTime(item);
                    showReservationModal();
                  }}
                  data={mapReservationAppointmentsForList(data)}
                />
              )}
              <Row>
                <Span>
                  <OTButtonGroup
                    fullWidth
                    type="big"
                    expectedCount={2}
                    collapseOnMobile
                  >
                    <OTButton
                      key={'back'}
                      color={'gray'}
                      onClick={() => previous()}
                      message={'back'}
                    />
                    {selectionView === 'CALENDAR' ? (
                      <OTButton
                        key={'reserve'}
                        onClick={() => showReservationModal()}
                        disabled={selectedTime === null}
                      >
                        <FormattedMessage
                          id={`${module_id}.reserve.selected.time`}
                        />
                        {selectedTime && (
                          <span className={'screen-reader-only'}>
                            {formatCustom(
                              selectedTime.dateStart,
                              'DD.MM.YYYY [klo] HH:mm - '
                            ) + formatCustom(selectedTime.dateEnd, 'HH:mm')}
                          </span>
                        )}
                      </OTButton>
                    ) : null}
                  </OTButtonGroup>
                </Span>
              </Row>
              {selectedTime && (
                <AppointmentReserveConfirmModal
                  modalIsOpen={modalIsOpen}
                  closeModal={hideReservationModal}
                  confirmTime={confirmTime}
                  isReserving={isReserving}
                  item={{
                    selectedTime: selectedTime,
                    comment: resolveComment(
                      selectedClinicKey,
                      selectedReasonKey
                    ),
                    selectedClinicKey,
                  }}
                />
              )}
            </>
          ) : (
            !error && (
              <NoReservableAppointmentsNotification
                clinic={selectedClinicKey}
                history={history}
              />
            )
          )}

          {error && (
            <Alert>
              <FormattedMessage id={`${module_id}.error`} />
            </Alert>
          )}
        </div>
      )}
    </>
  );
}
const mapStateToProps = (state) => {
  let { data, isFetching, error, isReserving, reservationError } =
    state[APPOINTMENTS].reservation.times;
  let {
    selectedClinicKey,
    selectedReasonKey,
    dueDate,
    data: clinicData,
  } = state[APPOINTMENTS].reservation.clinics;

  return {
    modalIsOpen: state[APPOINTMENTS].reservation.times.showModal,
    isReserving,
    reservationError,
    selectedClinicKey,
    selectedReasonKey,
    dueDate,
    data,
    isFetching,
    error,
    clinicData,
  };
};

export default connect(mapStateToProps, {
  showReservationModal,
  hideReservationModal,
  doGetTimesForClinic,
  doGetTimesForMaternityClinic,
  doReserveAppointment,
  resetAppointmentReservation,
})(withRouter(ReservationCalendarPage));
